import { Select } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const { Option } = Select;

export default function SelectSiNo({ value, onChange, disabled, onValueChange }) {
    const [risposte, setSiNo] = useState([]);

    useEffect(() => {
        var items = [
            {
                "value": 0,
                "text": "No"
            },
            {
                "value": 1,
                "text": "Si"
            }
        ];
        setSiNo(items);
        /*
        axios
            .get(`${process.env.REACT_APP_SERVER_URL}/api/aziende/all`)
            .then((response) => {
                setAziende(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
            */
    }, []);

    const handleChange = (val) => {
        const valoreSelezionato = risposte.find(a => a.value === val);
        if (onValueChange) {
            onValueChange(valoreSelezionato);
        }
        if (onChange) {
            onChange(val); // importante per AntD Form
        }
    };

    return (
        <Select
            showSearch
            style={{ width: 130 }}
            placeholder="Selezionare uns risposta"
            optionFilterProp="children"
            onChange={handleChange}
            onFocus={() => console.log('focus')}
            onBlur={() => console.log('blur')}
            onSearch={(val) => console.log('search:', val)}
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            value={
                risposte.some(r => r.value === value)
                    ? value
                    : undefined  
            }
            disabled={disabled}
        >
            {risposte.map((risp) => (
                <Option key={risp.value} value={risp.value}>
                    {risp.text}
                </Option>
            ))}
        </Select>
    );
}
